export default "__VITE_ASSET__DvBuqFBN__"